const csrPageDataAr = {
  headerImage : {
      name : "csr.jpg",
      alt : "Our corporate social responsibility",
  },
  mainTitle : "سياسة المسؤولية الاجتماعية لبنك الأول",
  paragraphOne : "يدرك بنك الأول بصفته مؤسسة مالية بارزة مسؤوليته في المساهمة بتحسين رفاه المجتمعات التي يعمل فيها. تشكل سياسة المسؤولية الاجتماعية التي ينتهجها البنك دليلًا مرجعيًا لاستثماراتنا في المجتمع. يمتلك بنك الأول، بصفته مؤسسة مالية بارزة، القدرة على تمويل المبادرات الخيرية والمشاركة فيها. تُعد مساهمة بنك الأول في المجتمعات جزءاً مهماً من نهج البنك في الاستدامة.",
  boxOne : {
      title : "أجندة الأعمال الخيرية المرتكزة على التأثير",
      subtitle : "في ضوء التزامنا كمؤسسة مالية رائدة تجاه المجتمع، أجرينا في العام 2022 تحديثات على سياسة المسؤولية الاجتماعية للبنك بحيث نضمن تحقيق أفضل قيمة ممكنة لكل ريال سعودي ننفقه وبما يعود بالفائدة على مجتمعاتنا على المدى البعيد. قمنا بمراجعة سياسة المسؤولية الاجتماعية للبنك بالتعاون مع شريكنا الاستراتيجي بنك إتش إس بي سي، ووضعنا بالاعتبار أثناء القيام بذلك السياق المحلي وأفضل الممارسات العالمية. توفر اللجنة التوجيهية المعنية بالممارسات البيئية والاجتماعية والحوكمة المؤسسية الخاصة ببنك الأول إرشادات الحوكمة والإدارة اللازمة للإشراف على ممارسات المسؤولية الاجتماعية للبنك وصناديق التبرعات، بما يضمن تحقيق أفضل قيمة ممكنة لكل ريال سعودي ينفقه البنك على الأنشطة الخيرية ذات الصلة. يقدم فريق الشريعة أيضًا إسهاماته في مشاريع المسؤولية الاجتماعية للبنك.",
  },
  boxTwo : {
      title : "مجالات التركيز الاستراتيجية للمسؤولية المجتمعية لبنك الأول",
      subtitle : "يركز إنفاقنا على المسؤولية الاجتماعية للشركات على مجالين رئيسيين هما:",
  },
  cards : [
      {
          title : "التعليم",
          subtitle : "التعليم هو مفتاح تحقيق الرخاء. فمن خلال مبادراتنا التعليمية، نساهم في تحقيق التنمية الشخصية ورفاه جيل الشباب. يركز بنك الأول على البرامج التعليمية التي تستهدف كل من الأطفال والبالغين من جميع الأعمار في المجالات التالية:",
          list : [
              "برامج للأطفال المحرومين أو للمدارس في المناطق المحرومة اقتصادياً",
              "التعليم الذي يرفع الوعي المالي والتجاري في المجتمع، وخصوصًا بين الشباب",
              "التثقيف البيئي حول تغير المناخ، والمياه العذبة، والتنوع البيولوجي البري",
          ],
      },
      {
          title : "الجوانب البيئية",
          subtitle : "تتعرض المملكة لتأثيرات تغير المناخ. وانطلاقًا من ذلك، نلتزم التزامًا تامًا بحماية البيئة وتعزيز نظام بيئي صحي يخدم جميع المواطنين السعوديين.  تركز جهودنا البيئية على الموضوعات التي تمس أعمالنا ومجتمعاتنا بشكل مباشر:",
          list : [
              "المحافظة على التنوع البيولوجي البري والموائل الطبيعية (بما في ذلك الغابات)",
              "أسباب وآثار تغير المناخ",
              "استدامة المياه العذبة",
          ],
      },
  ],
  paragraphTwo : "كما يمكن أن يخصص بنك الأول، وفقًا لتقدير اللجنة التوجيهية، أموالًا للأنشطة الخيرية الأخرى التي تتماشى مع استراتيجية الممارسات البيئية والاجتماعية والحوكمة المؤسسية للبنك.”",
  boxThree : {
      title : "معايير مشاريع المسؤولية الاجتماعية للبنك",
      subtitle : "يجب أن تسهم كل مبادرة جديدة للمسؤولية المجتمعية للبنك في:",
  },
  list : [
      "تحقيق فائدة مستدامة للمجتمع المحلي",
      "تحفيز موظفينا من خلال فرص المشاركة المباشرة قدر الإمكان",
      "تحقيق الفائدة للأشخاص والمجتمعات التي يعمل فيها بنك الأول",
      "التركيز على التعليم أو البيئة قدر الإمكان",
  ],
  paragraphThree : "ولضمان التطبيق الأمثل لممارسات حوكمة أنشطتنا الخيرية، تتولى اللجنة التوجيهية المعنية الحوكمة البيئية والاجتماعية و المؤسسية في البنك أيضاً مسؤولية توجيه التبرعات إلى المؤسسات الخيرية ذات السمعة الجيدة والمسجلة لدى وزارة العمل والتنمية الاجتماعية، والقادرة على إظهار تأثير ملموس.",
};

export default csrPageDataAr;